export default __webpack_public_path__ + "static/media/Flag of Brazil.c48ef27c.gif";